// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3npFi","header":"MergedInvoice_header__2_1qq"};